import { render } from "./ButtonLogOut.vue?vue&type=template&id=0e27f4e0&ts=true"
import script from "./ButtonLogOut.vue?vue&type=script&lang=ts"
export * from "./ButtonLogOut.vue?vue&type=script&lang=ts"

import exportComponent from "/fides/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__